import { useState } from 'react';
import useFulfilmentLocations from './useFulfilmentLocations';

const useShipmentState = () => {
  const locations = useFulfilmentLocations();
  const [contact, setContact] = useState(null);
  const [fromAddress, setFromAddress] = useState(null);
  const [fromLocation, setFromLocation] = useState(null);
  const [method, setMethod] = useState(null);
  const [shipment, setShipment] = useState(null);
  const [toAddress, setToAddress] = useState(null);
  const [toLocation, setToLocation] = useState(null);

  return {
    contact,
    fromAddress,
    fromLocation,
    locations,
    method,
    setContact,
    setFromAddress,
    setFromLocation,
    setMethod,
    setShipment,
    setToAddress,
    setToLocation,
    shipment,
    toAddress,
    toLocation,
  };
};

export default useShipmentState;
